import { datadogRum } from "@datadog/browser-rum";

import { env as ENV } from "./env";

const dataDogRUMWorker = () => {
  if (ENV.ddEnv === "local") {
    return;
  }

  datadogRum.init({
    applicationId: ENV.ddApplicationId,
    clientToken: ENV.ddClientToken,
    site: "datadoghq.com",
    service: ENV.ddServiceName,
    env: ENV.ddEnv,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
  });

  datadogRum.startSessionReplayRecording();
};

export default dataDogRUMWorker;
